import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import * as appConfig from './config/app-config.json'
import Dashboard from './dashboard';

export const authConfig = {
    "region": appConfig.region,
    "userPool": appConfig.userPool,
    "userPoolBaseUri": appConfig.userPoolBaseUri,
    "clientId": appConfig.clientId,
    "callbackUri": appConfig.callbackUri,
    "signoutUri": appConfig.signoutUri,
    "tokenScopes": [
        "openid",
        "email"
    ],

    appsConfigUrl: 'https://central.smartbrandscompany.com/assets/apps.json'
};

ReactDOM.render(
    <Dashboard />,
    document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
